import styled, { css } from 'styled-components'

import * as icons from '../svg/icons'

export const Content = styled.div`
  display: none;
`

const BaseWrapper = styled.div`
  width: 100%;

  ${icons.ChevronUp}, ${icons.ChevronDown} {
    margin-left: 10px;
  }
`

export const Wrapper = styled(BaseWrapper)<{ isOpen?: boolean }>`
  ${({ isOpen }) => {
    if (isOpen) {
      return css`
        ${Content}, ${icons.ChevronUp} {
          display: block;
        }

        ${icons.ChevronDown} {
          display: none;
        }
      `
    } else {
      return css`
        ${Content}, ${icons.ChevronUp} {
          display: none;
        }

        ${icons.ChevronDown} {
          display: block;
        }
      `
    }
  }}
`

export const Toggle = styled.button`
  align-items: center;
  border: 0px solid transparent;
  cursor: pointer;
  display: flex;
  margin: 0px;
  padding: 0px;
  width: 100%;

  &:hover,
  &:focus,
  &:active {
    outline: none;
  }
`

export const Title = styled.div`
  flex: 1;
  text-align: left;
`
